module.exports = __webpack_public_path__ + "img/sss2019.992cc284.png";